export const HEADER_AUTHORIZATION = "Authorization";
export const HEADER_CONTENT_TYPE = "Content-Type";
export const HEADER_TRANSACTION_ID = "X-Transaction-ID";
export const CONTENT_TYPE_JSON = "application/json";
export const CONTENT_TYPE_FORM = "application/x-www-form-urlencoded";
export const CONTENT_TYPE_IMAGE = "image/png";
export const GRANT_TYPE = "grantType";
export const GRANT_TYPE_REFRESH_TOKEN = "refresh_token";
export const HTTP_POST = "POST";
export const HTTP_GET = "GET";
export const HTTP_PUT = "PUT";
export const HTTP_DELETE = "DELETE";
export const HTTP_PATCH = "PATCH";
